const findUsedClients = (nodes) => {
    let used_client = [];
    for (const node of nodes) {
        if (node.type === 'application' || node.type === 'restfulapi') {
            if (node?.data?.general_properties?.name?.client_name) {
                used_client.push({
                    client_name: node?.data?.general_properties?.name?.client_name,
                    app_type: node?.data?.general_properties?.name?.app_type
                });
            }
        }
    }
    return used_client;
};

export default findUsedClients;